module.exports = {
  src: __webpack_public_path__ + "assets/images/integrations_photo.a6efd0c384c918ec.png",
  width: 393,
  height: 241,
  toString: function() { return __webpack_public_path__ + "assets/images/integrations_photo.a6efd0c384c918ec.png"; }
};